module.exports = __webpack_public_path__ + "static/media/login.efe513ec.svg";